export const CONTACTUS_INSTRUCTIONS_LOADED = 'CONTACTUS_INSTRUCTIONS_LOADED';
export const CONTACTUS_INSTRUCTIONS_LOAD_FAILED = 'CONTACTUS_INSTRUCTIONS_LOAD_FAILED';
export const CONTACTUS_CONTACTS_LOADED = 'CONTACTUS_CONTACTS_LOADED';
export const CONTACTUS_CONTACTS_LOAD_FAILED = 'CONTACTUS_CONTACTS_LOAD_FAILED';
